import injectSheet from 'react-jss'
import SeatTradeSearchResults from './SeatTradeSearchResults'
import styles from './SeatTradeSearchResults.styles'

export default injectSheet(styles)(SeatTradeSearchResults)
